import { Author } from './author';

export interface PhotoCategory {
  id: number | null;
  parent_id: number | null;
  name?: string;
  pivot?: {
    category_id?: number | null;
    photo_id?: number | null;
  };
}

export interface Photo {
  id: number;
  lang: number;
  country?: number;
  content?: string;
  title?: string;
  title_secondary?: string;
  title_secondary_translated?: string;
  display_title?: string;
  author?: string | Author;
  created_at: string;
  published_at?: number;
  is_published?: number;
  taken_at?: number | null;
  preview_photo?: string | null;
  author_id: number;
  author_name: string;
  author_last_name: string;
  created_by?: number;
  keywords?: string;
  categories: PhotoCategory[];
  subcategories?: number[];
  categories_translated?: PhotoCategory[];
  title_translated?: string;
  albums_count?: number;
}

export interface PhotoEdit {
  id?: number;
  original_id?: number;
  lang: number;
  author_id: number;
  country?: number;
  content?: string;
  content_translated?: string;
  title?: string;
  title_secondary?: string;
  title_secondary_translated?: string;
  title_translated?: string;
  preview_photo?: string | null;
  author_name?: string;
  author_last_name?: string;
  keywords?: string;
  keywords_translated?: string;
  is_published?: number;
  categories?: PhotoCategory[];
  published_at?: number;
  subcategory?: number[]; // for backend subcategories
  category?: number[]; // for backend categories
  categories_translated?: PhotoCategory[];
}

export const getPhotoDisplayTitle = (photo: Pick<Photo, 'title' | 'title_secondary' | 'display_title'>): string => {
  if (photo.display_title) {
    return photo.display_title;
  }

  const primary = (photo.title || '').trim();
  const secondary = (photo.title_secondary || '').trim();

  if (secondary && primary) {
    return `${secondary}. ${primary}`;
  }

  if (secondary) {
    return secondary;
  }

  return primary;
};
